const senderType = { technician: 1, coordinator: 2, system: 3 };

const chatStatus = { claimed: 3, closed: 4 };

const chatColors = { none: '#9e9e9e', waiting: '#9e9e9e', unread: '#da291c', seen: '#43a047' };

const readUpTo = (state, chat) =>
  Math.max(chat.lastReadMessageId || 0, state.readUpTo[chat.id] || 0);

const isUnread = (state, chat) => (chat.lastIncomingMessageId || 0) > readUpTo(state, chat);

// Сиво — няма активен чат или координатор още не го е поел; червено — има съобщение от координатор или колега, което
// още не е видяно (на сървъра или на това устройство) — и в приключен чат, докато не се види (сървърът връща
// приключения само с непрочетено); зелено — поет чат без непрочетени.
const chatIndicator = (state, predicate) => {
  const chats = state.activeChats.filter(predicate);
  if (chats.some(x => isUnread(state, x))) return 'unread';
  const chat = chats.find(x => x.status !== chatStatus.closed);
  if (!chat) return 'none';
  return chat.status === chatStatus.claimed ? 'seen' : 'waiting';
};

// Броят непрочетени: от сървъра (спрямо видяното там) и пристигналите след зареждането; видяното на това устройство
// след последното входящо го нулира. По задачата може да има и приключен непрочетен чат до активния — сборът.
const chatUnreadCount = (state, predicate) =>
  state.activeChats
    .filter(x => predicate(x) && isUnread(state, x))
    .reduce((sum, x) => sum + Math.max(x.unreadCount || 0, 1), 0);

export { senderType, chatColors, readUpTo, isUnread, chatIndicator, chatUnreadCount };
